/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Tailbase

// Helpers
function debounce(func, waitFor = 500) {
  var timeout;
  return function () {
    var context = this;
    var args = arguments;
    var later = function () {
      timeout = null;
      func.apply(context, args)
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, waitFor);
  };
}

// Product Detail Page
if (window.theme.pageType === 'product') {

  function hideElement(element, display = "block") {
    var elDisplay = window.getComputedStyle(element).display;
    if (elDisplay === display) {
      element.style.display = "none";
    }
  }
  // Toggle Functions
  function toggleElement(element, display = "block") {
    var elDisplay = window.getComputedStyle(element).display;
    if (elDisplay === "none") {
      element.style.display = display;
    } else {
      element.style.display = "none";
    }
  }

  function toggleElementText(element, hideText, showText) {
    if (hideText && showText) {
      if (element.innerHTML === hideText) {
        element.innerHTML = showText;
      } else {
        element.innerHTML = hideText;
      }
    }
  }

  // View more Button
  var viewMoreBtn = document.getElementsByClassName('product-form__rebate-view-more-btn');
  var truncatedText = document.getElementsByClassName('product-meta__truncated-description');
  var completeText = document.getElementsByClassName('product-meta__complete-text');

  function viewDescriptionBehavior() {
    if (viewMoreBtn.length > 0 && truncatedText.length > 0 && completeText.length > 0) {
      toggleElement(truncatedText[0], 'inline');
      toggleElement(completeText[0], 'inline');
      toggleElementText(viewMoreBtn[0], window.languages.viewMore, window.languages.viewLess);

      var productInfoElement = document.querySelector('.product-block-list__item--info .card');

      if (productInfoElement) {
        document.querySelector('.product-block-list__wrapper').style.minHeight = "".concat(productInfoElement.clientHeight, "px");
      }
    }
  }

  if (viewMoreBtn.length > 0 && truncatedText.length > 0 && completeText.length > 0) {
    viewMoreBtn[0].addEventListener('click', function () {
      viewDescriptionBehavior();
    });
    viewMoreBtn[0].addEventListener('keyup', (e) => {
      if (e.key === 'Enter') viewDescriptionBehavior();
    });
  }

  // Rebate Learn More Toggle
  var rebateLearnMore = document.getElementsByClassName('product-form__rebate-learn');
  var rebateInfo = document.getElementsByClassName('product-form__rebate-info');
  var rebates = document.getElementsByClassName('product-form__rebates');
  var warehouseBody = document.getElementsByClassName('warehouse--v1');

  function handleDesktopLearnMoreClick(e) {
    toggleElement(rebateInfo[0]);
    e.stopPropagation();
  }

  function handleMobileLearnMoreClick() {
    scrollToWithOffSet(rebates[0], 100)
  }

  function handleRebateInfoClick(e) {
    e.stopPropagation();
  }

  function handleBodyClick() {
    hideElement(rebateInfo[0]);
  }

  function rebateBehavior() {
    if (rebateLearnMore.length > 0 && rebateInfo.length > 0 && warehouseBody.length > 0 && rebates.length > 0) {
      var isDesktop = window.matchMedia('screen and (min-width: 1000px)').matches;
      var isMobile = window.matchMedia('screen and (max-width: 999px)').matches;

      if (isDesktop) {
        rebateLearnMore[0].removeEventListener('click', handleMobileLearnMoreClick);
        warehouseBody[0].addEventListener('click', handleBodyClick);
        rebateLearnMore[0].addEventListener('click', handleDesktopLearnMoreClick);
        rebateInfo[0].addEventListener('click', handleRebateInfoClick);
        rebateLearnMore[0].addEventListener('keyup', function(e) {
          if (e.key === 'Enter') handleDesktopLearnMoreClick();
        });
      }
      if (isMobile) {
        rebateLearnMore[0].removeEventListener('click', handleDesktopLearnMoreClick);
        rebateInfo[0].removeEventListener('click', handleRebateInfoClick);
        rebateLearnMore[0].addEventListener('click', handleMobileLearnMoreClick);
        rebateLearnMore[0].addEventListener('keyup', function(e) {
          if (e.key === 'Enter') handleMobileLearnMoreClick();
        });
      }
    }
  }

  var debouncedRebateBehavior = debounce(rebateBehavior);

  // PERF: listeners passifs
  window.addEventListener('resize', debouncedRebateBehavior, { passive: true });
  window.addEventListener('load', rebateBehavior);

  // Tabs
  var productTabsSection = document.getElementById("product-tabs-section");
  if (productTabsSection) {
    var productTabsoptions = JSON.parse(productTabsSection.getAttribute('data-section-settings'));
  
    var productTabsMenu = document.getElementsByClassName('product_tabs__titles');
    var header = document.getElementById("shopify-section-header");
  
    if (productTabsMenu.length > 0 && header) {
      let productTabsMenuOffsetTop = getTopPosition(productTabsMenu[0]);
      const mqDesktop = window.matchMedia('(min-width: 1000px)');

      // Re-measure on resize (or if fonts/images shift layout)
      const remeasure = () => {
        productTabsMenuOffsetTop = getTopPosition(productTabsMenu[0]);
      };
      window.addEventListener('resize', remeasure, { passive: true });
      window.addEventListener('load', remeasure, { passive: true });

      // rAF throttle to avoid running work on every scroll tick
      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          if (mqDesktop.matches) {
            if (window.scrollY > (productTabsMenuOffsetTop - 200)) {
              header.classList.add('hide-header-desktop');
              productTabsMenu[0].classList.add('tabs-titles-sticky');
              if (rebateInfo.length > 0) rebateInfo[0].style.display = 'none';
            } else {
              header.classList.remove('hide-header-desktop');
              productTabsMenu[0].classList.remove('tabs-titles-sticky');
            }
          } else {
            // Ensure classes are cleaned up on mobile
            header.classList.remove('hide-header-desktop');
            productTabsMenu[0].classList.remove('tabs-titles-sticky');
          }
          ticking = false;
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
    }
  
    var featuresLink = document.getElementById("features-title");
    var featuresContent = document.getElementById("product-features");
  
    var specsLink = document.getElementById("specs-title");
    var specsContent = document.getElementById("product-specs");
  
    var documentsLink = document.getElementById("documents-title");
    var documentsContent = document.getElementById("product-documents");
  
    var associatedProductsLink = document.getElementById("associated-products-title");
    var associatedProductsContent = document.getElementById("product-associated-products");

    var faqLink = document.getElementById("faq-title");
    var faqContent = document.getElementById("product-faq");

    var backToProductInfoMenuBtn = document.getElementsByClassName("product_tabs__menu-btn");
    var productInfoMenu = document.getElementById("product-info-menu");

    if (featuresLink && featuresContent) scrollToWithOffSetListener(featuresLink, featuresContent, productTabsoptions.defaultOffset);
    if (specsLink && specsContent) scrollToWithOffSetListener(specsLink, specsContent, productTabsoptions.defaultOffset);
    if (documentsLink && documentsContent) scrollToWithOffSetListener(documentsLink, documentsContent, productTabsoptions.defaultOffset);
    if (associatedProductsLink && associatedProductsContent) scrollToWithOffSetListener(associatedProductsLink, associatedProductsContent, productTabsoptions.defaultOffset);
    if (faqLink && faqContent) scrollToWithOffSetListener(faqLink, faqContent, productTabsoptions.defaultOffset);
  
    if (backToProductInfoMenuBtn.length > 0 && productInfoMenu) {
      for (var i = 0; i < backToProductInfoMenuBtn.length; i++) {
        scrollToWithOffSetListener(backToProductInfoMenuBtn.item(i), productInfoMenu, productTabsoptions.defaultOffset);
      }
    }
  }
 

  function scrollToWithOffSetListener(link, content, offset) {
    // Pour les boutons (pas des liens <a>), on gère le clic nous-mêmes
    // Les liens <a> avec data-offset sont gérés par theme.js
    if (link.tagName !== 'A') {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        scrollToWithOffSet(content);
      });
    }
    link.addEventListener('keyup', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        scrollToWithOffSet(content);
      }
    });
  }

  function scrollToWithOffSet(content) {
    // Calculer la position avec offset pour le header sticky
    var header = document.getElementById('shopify-section-header');
    var headerHeight = header ? header.offsetHeight : 0;
    var margin = 20;

    var rect = content.getBoundingClientRect();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var targetPosition = rect.top + scrollTop - headerHeight - margin;

    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
  }

  function getTopPosition(content) {
    var rect = content.getBoundingClientRect();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop;
  }

  // Add To cart

  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    const newAction = productForm.action.replace("/add", "");
    const validateInstallationProducts = document.getElementsByClassName('installation product-form__validate-products');
    const validateWarrantyProducts = document.getElementsByClassName('warranty product-form__validate-products');
    const isInstallationValidating = validateInstallationProducts.length > 0;
    const isWarrantyValidating = validateWarrantyProducts.length > 0;
    const warrantyDropdownSelect = document.getElementById("add-to-cart-products__dropdown");
    let installationInputHasChanged = false;
    let warrantyInputHasChanged = false;
    let isInstallationValidated = false;
    let isWarrantyValidated = false;
    if (isInstallationValidating) {
      const installationInputs = document.getElementsByClassName('installation add-to-cart-product__checkbox');
      Array.from(installationInputs).forEach((input) => {
        input.addEventListener('change', () => {
          handleNoneForCheckbox(input, installationInputs);
          installationInputHasChanged = true;
        });
      });
    }
    if (isWarrantyValidating) {
      const warrantyInputs = document.getElementsByClassName('warranty add-to-cart-product__checkbox');
      Array.from(warrantyInputs).forEach((input) => {
        input.addEventListener('change', () => {
          handleNoneForCheckbox(input, warrantyInputs);
          warrantyInputHasChanged = true;
        });
      });

      if (warrantyDropdownSelect !== null) {
        warrantyDropdownSelect.addEventListener('change', () => {
          warrantyInputHasChanged = true;
        });
      }
    }

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (isInstallationValidating || isWarrantyValidating) {
        if (isInstallationValidating && !isInstallationValidated && !installationInputHasChanged) {
          displayValidationMessage(validateInstallationProducts);
          isInstallationValidated = true;
          if (!isWarrantyValidating || warrantyInputHasChanged) return;
        }
        if (isWarrantyValidating && !isWarrantyValidated && !warrantyInputHasChanged) {
          displayValidationMessage(validateWarrantyProducts);
          isWarrantyValidated = true;
          return;
        }
      }
      
      // Check if some add to cart products are checked
      var checkboxes = document.getElementsByClassName("add-to-cart-product__checkbox");
      var addToCartProducts = [];

      for (const checkbox of checkboxes) {
        if (checkbox.checked && checkbox.getAttribute("data-variant")) {
          const productToAdd = {
            id: checkbox.getAttribute("data-variant"),
            quantity: '1'
          };
          addToCartProducts.push(productToAdd);
        }
      }

      // Check if some add to cart product is selected from Warranty Dropdown
      if (warrantyDropdownSelect !== null) {
        var selectedOption = warrantyDropdownSelect.options[warrantyDropdownSelect.selectedIndex];
        var dataVariant = selectedOption.getAttribute("data-variant");
        if (dataVariant != "") {
          var productToAdd = {
            id: dataVariant,
            quantity: '1'
          };
          addToCartProducts.push(productToAdd);
        }
      }

      let formData = new FormData(productForm);
      var products = [...addToCartProducts, { id: formData.get("id"), quantity: formData.get("quantity") }];
      fetch('/cart/add.js', {
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: products }),
        method: 'POST'
      })
        .then(response => {
          location.href = newAction;
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });

    function displayValidationMessage(elements) {
      Array.from(elements).forEach((element) => {
        element.style.display = 'block';
      });
    }
  
    function handleNoneForCheckbox(input, elements) {
      if (input.hasAttribute("none") && input.classList.contains("checkbox")) {
        removeAllButNone(elements);
      } else if (input.classList.contains("checkbox")) {
        removeNone(elements);
      }
    }
  
    function removeNone(parentEl) {
      Array.from(parentEl).forEach((input) => {
        if (input.hasAttribute("none")) {
          input.checked = false;
        }
      });
    }
  
    function removeAllButNone(parentEl) {
      Array.from(parentEl).forEach((input) => {
        if (!input.hasAttribute("none")) {
          input.checked = false;
        }
      });
    }
  }

  // Syndigo
  const p = document.querySelector('syndigo-powerpage');
  if (p) {
    p.addEventListener('content', function (ev) {
      if (!ev.detail.hasContent) {
        p.remove();
      }
    });
  }

  // loadbee
  window.addEventListener('load', () => {
    const loadbeeContainer = document.querySelector('#product-manufacturer-loadbee');
    if (!loadbeeContainer) return;

    setTimeout(() => {
      const tabContent = loadbeeContainer.querySelector('.loadbeeTabContent');
      if (tabContent && tabContent.children.length > 0) {
        loadbeeContainer.style.display = 'block';
      }
    }, 1000);
  });
}

document.addEventListener("DOMContentLoaded", function () {

  const breadcrumbList = document.querySelector(".breadcrumb__list");
  if (!breadcrumbList) return;

  const isCollectionPage = window.location.pathname.includes("/collections/");
  const isProductPage = window.location.pathname.includes("/products/");

  // 1️⃣ On collection pages: store current collection in localStorage
  if (isCollectionPage) {
    const collectionTitle = document.querySelector("h1")?.innerText || "";
    const collectionUrl = window.location.pathname;
    if (collectionTitle && collectionUrl) {
      localStorage.setItem("lastCollectionTitle", collectionTitle);
      localStorage.setItem("lastCollectionUrl", collectionUrl);
    }
  }

  if (isProductPage) {
    const lastTitle = localStorage.getItem("lastCollectionTitle");
    const lastUrl = localStorage.getItem("lastCollectionUrl");

    if (!lastTitle || !lastUrl) return;

    const hasCollection = breadcrumbList.querySelector(".breadcrumb__item a[href*='/collections/']");
    if (hasCollection) return; 

    const li = document.createElement("li");
    li.className = "breadcrumb__item";

    li.innerHTML = `
      <a class="breadcrumb__link link" href="${lastUrl}">${lastTitle}</a>
      <svg class="icon"><use xlink:href="#icon-arrow-right"></use></svg>
    `;

    breadcrumbList.insertBefore(li, breadcrumbList.lastElementChild);
  }

});

document.addEventListener('DOMContentLoaded', () => {
  const panel  = document.getElementById('mini-cart');
  const toggle = document.querySelector('.header__cart-toggle');
  if (!panel || !toggle) return;

  // Focus trap
  function trapFocus(container){
    const SEL = [
      'a[href]','button:not([disabled])','input:not([disabled])',
      'select:not([disabled])','textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');
    function handler(e){
      if (e.key !== 'Tab') return;
      const nodes = container.querySelectorAll(SEL);
      if (!nodes.length) return;
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    return () => container.removeEventListener('keydown', handler);
  }

  let removeTrap = null, lastFocus = null;

  function onOpen(){
    lastFocus = document.activeElement;
    toggle.setAttribute('aria-expanded','true');
    const title = panel.querySelector('#mini-cart-title') || panel;
    title.setAttribute('tabindex','-1');
    title.focus();
    removeTrap = trapFocus(panel);
  }

  function onClose(){
    toggle.setAttribute('aria-expanded','false');
    if (removeTrap) { removeTrap(); removeTrap = null; }
    (lastFocus || toggle)?.focus();
  }

  // Observe l'état natif du thème
  const obs = new MutationObserver(() => {
    panel.getAttribute('aria-hidden') === 'false' ? onOpen() : onClose();
  });
  obs.observe(panel, { attributes: true, attributeFilter: ['aria-hidden'] });

  // Bouton "Fermer" interne
  panel.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-close-cart]');
    if (!btn) return;
    e.preventDefault();
    panel.setAttribute('aria-hidden','true'); // ferme via l'API du thème
  });

  // Échap pour fermer
  panel.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') panel.setAttribute('aria-hidden','true');
  });

  // Live region / compteur
  window.updateCartCount = function(n){
    const live   = document.getElementById('cart-count-live');
    const visual = document.querySelector('.header__cart-count');
    const itemLabel  = (window.i18n && window.i18n.item)  || 'item';
    const itemsLabel = (window.i18n && window.i18n.items) || 'items';
    if (visual) visual.textContent = n;
    if (live)   live.textContent   = `${n} ${n > 1 ? itemsLabel : itemLabel}`;
  };
});

/* ============================================
   Accessibilité: neutraliser les focusables quand aria-hidden="true"
   ============================================ */
(function(){
  // Exécute le travail non critique quand le navigateur est "au repos"
  function schedule(fn){
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: 2000 });
    } else {
      setTimeout(fn, 0);
    }
  }

  document.addEventListener('DOMContentLoaded', function(){
    schedule(function(){
      const CONTAINERS = '.slideshow__slide, .product-item';
      const FOCUSABLE  = 'a[href], button, input, select, textarea, [tabindex]';

      function applyFocusability(container) {
        const isHidden = container.getAttribute('aria-hidden') === 'true';

        // inert si dispo (sinon, on gère tabindex/aria-disabled)
        if ('inert' in container) {
          container.inert = isHidden;
        }

        container.querySelectorAll(FOCUSABLE).forEach(el => {
          if (isHidden) {
            if (!el.hasAttribute('data-orig-tabindex') && el.hasAttribute('tabindex')) {
              el.setAttribute('data-orig-tabindex', el.getAttribute('tabindex'));
            }
            el.setAttribute('tabindex', '-1');
            el.setAttribute('aria-disabled', 'true');
          } else {
            if (el.hasAttribute('data-orig-tabindex')) {
              el.setAttribute('tabindex', el.getAttribute('data-orig-tabindex'));
              el.removeAttribute('data-orig-tabindex');
            } else {
              el.removeAttribute('tabindex');
            }
            el.removeAttribute('aria-disabled');
          }
        });
      }

      function init() {
        document.querySelectorAll(CONTAINERS).forEach(applyFocusability);
      }

      const mo = new MutationObserver(muts => {
        for (const m of muts) {
          if (m.type === 'attributes' &&
              m.attributeName === 'aria-hidden' &&
              m.target.matches(CONTAINERS)) {
            applyFocusability(m.target);
          }
        }
      });

      init();
      document.querySelectorAll(CONTAINERS).forEach(el => {
        mo.observe(el, { attributes: true, attributeFilter: ['aria-hidden'] });
      });

      // (Facultatif) si des sections Shopify rechargent le DOM :
      document.addEventListener('shopify:section:load', init);
      document.addEventListener('shopify:section:select', init);
    });
  });
})();

/* ============================================
   Perf: Pop-Convert uniquement à l’INTERACTION
   (GTM: Tag "PopConvert – lazy" sur Custom Event 'popconvert_boot')
   ============================================ */
(function(){
  if (window.__pc_init) return;
  window.__pc_init = true;

  function fire() {
    if (sessionStorage.getItem('pc_booted')) return;
    sessionStorage.setItem('pc_booted','1');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'popconvert_boot' });
  }

  const opts = { passive: true, once: true };
  ['click','scroll','keydown','mousemove','touchstart'].forEach(evt =>
    window.addEventListener(evt, fire, opts)
  );

  // filet de sécurité si aucune interaction
  setTimeout(fire, 20000);
})();



/* ============================================
   Tabs for Product Page
   ============================================ */
document.addEventListener('DOMContentLoaded', function () {
  var tabContainers = document.querySelectorAll('[data-product-tabs]');
  if (!tabContainers.length) return;

  tabContainers.forEach(function (container) {
    var buttons = container.querySelectorAll('[data-tab-button]');
    var panels = container.querySelectorAll('[data-tab-panel]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-tab-button');

        // Désactiver tous les onglets
        buttons.forEach(function (btn) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-selected', 'false');
        });

        // Cacher tous les panels
        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
          panel.setAttribute('hidden', 'true');
        });

        // Activer le bouton cliqué
        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');

        // Afficher le panel correspondant
        var activePanel = container.querySelector('[data-tab-panel="' + target + '"]');
        if (activePanel) {
          activePanel.classList.add('is-active');
          activePanel.removeAttribute('hidden');
        }
      });
    });
  });
});

/* ============================================
   Trustify Review Schema Injection
   Injects aggregateRating into existing Product schema or creates new one
   Trustify renders .trustify-review-stars with data-review-avg and data-review-count
   ============================================ */
document.addEventListener("DOMContentLoaded", function () {
  // Only run on product pages
  if (window.theme && window.theme.pageType !== 'product') return;

  const observer = new MutationObserver(() => {
    // Trustify widget selector - check multiple possible selectors
    const reviewElement = document.querySelector('.trustify-review-stars[data-review-avg], .trustify-widget[data-review-avg], [data-trustify-review-avg]');
    if (!reviewElement) return;

    // Get review data from data attributes
    const reviewAvg = parseFloat(reviewElement.dataset.reviewAvg || reviewElement.dataset.trustifyReviewAvg || 0);
    const reviewCount = parseInt(reviewElement.dataset.reviewCount || reviewElement.dataset.trustifyReviewCount || 0, 10);

    if (reviewAvg > 0 && reviewCount > 0) {
      // Avoid duplicate injection
      if (document.getElementById('trustify-review-snippet-product')) return;

      // Try to find and update existing Product schema
      const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
      let productSchemaUpdated = false;

      existingScripts.forEach(script => {
        try {
          const data = JSON.parse(script.textContent);
          if (data['@type'] === 'Product' && !data.aggregateRating) {
            // Add aggregateRating to existing Product schema
            data.aggregateRating = {
              "@type": "AggregateRating",
              "ratingValue": reviewAvg.toFixed(2),
              "reviewCount": reviewCount,
              "worstRating": "1",
              "bestRating": "5"
            };
            script.textContent = JSON.stringify(data);
            productSchemaUpdated = true;
          }
        } catch (e) {
          // Not valid JSON, skip
        }
      });

      // Mark as done even if schema was updated via Liquid
      if (productSchemaUpdated) {
        const marker = document.createElement('div');
        marker.id = 'trustify-review-snippet-product';
        marker.style.display = 'none';
        document.body.appendChild(marker);
      }

      // If no existing Product schema was found/updated, create a minimal one
      if (!productSchemaUpdated) {
        const productName = document.querySelector('h1.product-meta__title, h1[data-ehf-title], .product__title h1');
        const productUrl = window.location.href.split('?')[0];

        const jsonLd = {
          "@context": "https://schema.org",
          "@type": "Product",
          "name": productName ? productName.textContent.trim() : document.title,
          "url": productUrl,
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": reviewAvg.toFixed(2),
            "reviewCount": reviewCount,
            "worstRating": "1",
            "bestRating": "5"
          }
        };

        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = 'trustify-review-snippet-product';
        script.textContent = JSON.stringify(jsonLd);
        document.head.appendChild(script);
      }

      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

/* ============================================
   Trustify FR Translation "reviews" -> "avis"
   ============================================ */
document.addEventListener("DOMContentLoaded", function () {
  if (!window.location.pathname.startsWith("/fr")) return;

  const interval = setInterval(() => {
    const captionSpan = document.querySelector(".tr-review-stars__caption");
    if (captionSpan && captionSpan.textContent.trim().toLowerCase() === "reviews") {
      captionSpan.textContent = " avis";
      clearInterval(interval);
    }
  }, 200);

  // Stop checking after 10 seconds
  setTimeout(() => clearInterval(interval), 10000);
});

/* ============================================
   Mobile Search Bar Handler
   Consolidated from theme.liquid inline scripts
   ============================================ */
document.addEventListener("DOMContentLoaded", function() {
  const mq = window.matchMedia("(max-width: 989px)");
  const wrapper = document.querySelector(".header__search-bar-wrapper");
  const openBtn = document.querySelector('[data-action="toggle-search"]');
  const closeBtn = document.querySelector('[data-action="unfix-search"]');

  if (!wrapper || !openBtn || !closeBtn) return;

  function resetWrapper() {
    wrapper.removeAttribute("style");
    wrapper.style.display = "none";
    wrapper.style.marginTop = "0";
    wrapper.classList.remove("is-fixed", "is-visible");
  }

  function forceOpen() {
    resetWrapper();
    setTimeout(function() {
      wrapper.classList.add("is-fixed", "is-visible");
      wrapper.style.display = "block";
      wrapper.style.marginTop = "0";
      const input = wrapper.querySelector(".search-bar__input");
      if (input) input.focus();
    }, 20);
  }

  function forceClose() {
    wrapper.classList.remove("is-fixed", "is-visible");
    const input = wrapper.querySelector(".search-bar__input");
    if (input) input.blur();
    setTimeout(resetWrapper, 150);
  }

  openBtn.addEventListener("click", function(e) {
    if (!mq.matches) return;
    e.preventDefault();
    forceOpen();
  });

  closeBtn.addEventListener("click", function(e) {
    if (!mq.matches) return;
    e.preventDefault();
    forceClose();
  });

  document.addEventListener("click", function(e) {
    if (!mq.matches) return;
    if (!wrapper.classList.contains("is-visible")) return;
    const inside = e.target.closest(".header__search-bar-wrapper");
    const openToggle = e.target.closest('[data-action="toggle-search"]');
    if (!inside && !openToggle) {
      forceClose();
    }
  });
});

/* ============================================
   EHF Product Page | Product Info Section
   ============================================ */
document.addEventListener('DOMContentLoaded', function () {
  // ----- Récupération des données de variants -----
  var variantsScript = document.querySelector('[data-ehf-variants]');
  var variants = [];

  if (variantsScript) {
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      console.warn('EHF: unable to parse variants JSON', e);
    }
  }

  function findVariantById(id) {
    id = Number(id);
    return variants.find(function (v) { return Number(v.id) === id; });
  }

  // ----- Elements principaux -----
  var priceEl = document.querySelector('[data-ehf-price]');
  var floatingPriceEl = document.querySelector('[data-ehf-floating-price]');
  var skuEl = document.querySelector('[data-ehf-sku]');
  var upcEl = document.querySelector('[data-ehf-upc]');
  var variantSelect = document.querySelector('[data-ehf-variant-select]');
  var mainAtc = document.querySelector('[data-ehf-main-atc]');
  var floatingAtc = document.querySelector('[data-ehf-floating-atc]');

  // Gallery (desktop)
  var slides = document.querySelectorAll('[data-ehf-gallery-slide]');
  var thumbs = document.querySelectorAll('.product-gallery__thumb');

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney && window.Shopify.money_format) {
      return Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return (cents / 100).toFixed(2);
  }

  function setActiveImageByImageId(imageId) {
    if (!imageId) return;
    imageId = Number(imageId);

    slides.forEach(function (slide) {
      var slideId = Number(slide.getAttribute('data-image-id'));
      slide.classList.toggle('is-active', slideId === imageId);
    });

    thumbs.forEach(function (thumb) {
      var thumbId = Number(thumb.getAttribute('data-image-id'));
      thumb.classList.toggle('is-active', thumbId === imageId);
    });

    // Sur mobile, scroll jusqu'à la slide correspondante si possible
    var mobileTrack = document.querySelector('[data-ehf-gallery-mobile]');
    if (mobileTrack) {
      var targetSlide = mobileTrack.querySelector('[data-image-id="' + imageId + '"]');
    }
  }

  // Thumbnails click -> image active
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var imageId = thumb.getAttribute('data-image-id');
      setActiveImageByImageId(imageId);
    });
  });

  // ----- Changement de variant (select) -----
  if (variantSelect && variants.length) {
    variantSelect.addEventListener('change', function () {
      var variantId = variantSelect.value;
      var variant = findVariantById(variantId);
      if (!variant) return;

      // Mettre à jour le prix
      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }
      if (floatingPriceEl) {
        floatingPriceEl.textContent = formatMoney(variant.price);
      }

      // SKU / UPC
      if (skuEl) {
        skuEl.textContent = variant.sku || '';
      }
      if (upcEl) {
        upcEl.textContent = variant.barcode || '';
      }

      // Image principale
      if (variant.featured_image && variant.featured_image.id) {
        setActiveImageByImageId(variant.featured_image.id);
      }
    });
  }

  // ----- Bouton ATC flottant = déclenche le bouton principal -----
  if (floatingAtc && mainAtc) {
    floatingAtc.addEventListener('click', function () {
      mainAtc.click();
    });
  }

  // ----- Tabs (desktop & mobile) -----
  var tabContainers = document.querySelectorAll('[data-product-tabs]');
  tabContainers.forEach(function (container) {
    var buttons = container.querySelectorAll('[data-tab-button]');
    var panels = container.querySelectorAll('[data-tab-panel]');
    if (!buttons.length || !panels.length) return;

    var isMobile = window.matchMedia('(max-width: 768px)').matches;

    // Desktop : activer automatiquement le 1er onglet si aucun actif
    if (!isMobile) {
      buttons[0].classList.add('is-active');
      buttons[0].setAttribute('aria-selected', 'true');
      panels[0].classList.add('is-active');
      panels[0].removeAttribute('hidden');
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-tab-button');

        // Désactiver tous les onglets
        buttons.forEach(function (btn) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-selected', 'false');
        });

        // Cacher tous les panels
        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
          panel.setAttribute('hidden', 'true');
        });

        // Activer celui cliqué
        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');

        var activePanel = container.querySelector('[data-tab-panel="' + target + '"]');
        if (activePanel) {
          activePanel.classList.add('is-active');
          activePanel.removeAttribute('hidden');
        }
      });
    });
  });
});

/* ============================================
   YouTube/Vimeo Video Facade
   Lazy loads video only when user clicks
   ============================================ */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.video-facade').forEach(function(facade) {
    facade.addEventListener('click', function() {
      var videoId = facade.getAttribute('data-video-id');
      var videoHost = facade.getAttribute('data-video-host');
      var loop = facade.getAttribute('data-video-loop') === '1';
      var iframe;

      if (videoHost === 'youtube') {
        var loopParam = loop ? '&loop=1&playlist=' + videoId : '';
        iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0' + loopParam);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%;';
      } else if (videoHost === 'vimeo') {
        var loopParam = loop ? '&loop=1' : '';
        iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://player.vimeo.com/video/' + videoId + '?autoplay=1' + loopParam);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%;';
      }

      if (iframe) {
        facade.innerHTML = '';
        facade.appendChild(iframe);
        facade.style.cursor = 'default';
        facade.classList.remove('video-facade');
      }
    });
  });
});
